// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"bc7f153a24b95795","src_app_pages_transactions_transactions_module_ts":"a9784d3d94851396","src_app_pages_settings_settings_module_ts":"17dd599eddc4d4a8","node_modules_echarts_index_js":"77745d9a8e26b71a"}[chunkId] + ".js";
};